import { EuiHorizontalRule } from "@elastic/eui";
import React from "react";
import { PricelistTableRow, RowType } from "utils/types";

export const RowDivider = <T,>({
    row,
    column,
    color,
}: {
    row: PricelistTableRow<unknown>;
    column: PricelistTableRow<T>[];
    color: string;
}) => {
    return row.type === RowType.DataRow ? (
        <EuiHorizontalRule className="rowDivider" style={{ borderColor: `#${color}` }} margin={"none"} />
    ) : (
        <></>
    );
};
